module.exports = __webpack_public_path__ + "img/12.af20f3b0.webp";